// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportingConfigurationStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import UiState from 'logic/Izenda.UiState';
import { observable, action } from 'mobx';
import ExportingConfiguration from './models/Izenda.ExportingConfiguration';
import AlertDetails from 'logic/models/Izenda.AlertDetails';
import fetcher from 'fetchers/Izenda.SystemSettingFetcher';

import { get } from 'lodash/fp';
export default class ExportingConfigurationStore {
  @observable exportingConfiguration = new ExportingConfiguration();
  @observable alertDetails = new AlertDetails();

  noDirtyFnRegistration: false; // if true - we don't register dirty function in uiStore.
  dirtyFn = () => get('isDirty', this); // Dirty check function

  constructor(noDirtyFnRegistration) {
    this.noDirtyFnRegistration = !!noDirtyFnRegistration;
  }

  /**
   * Init Exporting configuration store
   */
  init() {
    if (!this.noDirtyFnRegistration)
      UiState.setCheckDirtyFunction(this.dirtyFn);
  }

    /**
   * Load Exporting configuration
   */
  loadExportingConfiguration() {
    return fetcher.loadExportingConfiguration().then(
      action(result => {
        this.exportingConfiguration.populateData(result);
        this.resetDirty();
        this.alertDetails.reset();
        return result;
      })
    );
  }

  /**
   * Save Exporting configuration
   */
  saveExportingConfiguration() {
    return fetcher.saveExportingConfiguration(this.exportingConfiguration.buildDataForSave()).then(result => {
      if (result.success) {
        const { exportQueueSetting } = result;
        this.exportingConfiguration.populateData(exportQueueSetting);
        this.resetDirty();
      }
      return result;
    });
  }

  /**
   * Set value by key
   */
  setValueByKey(key: string, value: any) {
    this.exportingConfiguration.setValueByKey(key, value);
    this.isDirty = true;
  }

    /**
   * Reset dirty
   */
  resetDirty() {
    this.isDirty = false;
  }

  /**
   * Destroy Exporting configuration store
   */
  destroy() {
    if (!this.noDirtyFnRegistration)
      UiState.resetCheckDirtyFunction();
  }
}



// WEBPACK FOOTER //
// ./ui/logic/Izenda.ExportingConfigurationStore.js